<template>
<p v-if="documents.length > 0">
  Нажимая на кнопку выше, вы соглашаетесь с <LegalDocumentsLinks />.
</p>
</template>

<script>
import { mapGetters } from 'vuex';
import LegalDocumentsLinks from '@/components/legal/LegalDocumentsLinks.vue';

export default {
  components: {
    LegalDocumentsLinks,
  },

  computed: {
    ...mapGetters({
      documents: 'settings/legalDocsLinks',
    }),
  },
}
</script>
